module.exports = __webpack_public_path__ + "static/media/design.3fce729c.png";